const Enum = [
    "Aguardando",
    "Negado",
    "Confirmado"
];

export default Enum;